import { apiFetch } from '../api';

export const TENANT_TOKEN_KEY = 'virgil_tenant_token';

export function getTenantToken() {
  return localStorage.getItem(TENANT_TOKEN_KEY);
}

export function setTenantToken(token) {
  if (token) localStorage.setItem(TENANT_TOKEN_KEY, token);
  else localStorage.removeItem(TENANT_TOKEN_KEY);
}

export function tenantApiFetch(path, options = {}) {
  const token = getTenantToken();
  const headers = { Accept: 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  let body = options.body;
  if (body && typeof body === 'object' && !(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    body = JSON.stringify(body);
  }

  return apiFetch(path, { ...options, headers, body });
}
